<template>
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.97656 5.99934L0.851562 1.46184L2.02989 0.165674L7.33323 5.99934L2.0299 11.833L0.851562 10.5368L4.97656 5.99934Z" fill="#302F2F"/>
  </svg>
</template>